import { useQuery } from "@tanstack/react-query";
import apiClient from "../../../../../lib/api_client";

// Some categories come back with a placeholder instead of an empty list -
// Brooches returns {"sizes":["None"]} where Bali returns {"sizes":[]}. Both
// mean the same thing: nothing to choose from. Dropping the placeholder here
// keeps every caller agreeing, so the size dropdown reads N/A and the size
// check on PROCEED does not ask for a size that cannot be picked.
const isRealSize = (size) =>
  typeof size === "string" && size.trim() !== "" &&
  size.trim().toLowerCase() !== "none";

export const fetchItemSizes = async ({ queryKey }) => {
  const [, { categoryName, subCategoryName }] = queryKey;
  const { data } = await apiClient.get(
    `/getCategorySizeList/${categoryName}?subCategoryName=${subCategoryName}`
  );
  return (data?.sizes || []).filter(isRealSize);
};

export const useItemSizes = ({ categoryName = "", subCategoryName = "" }) => {
  return useQuery({
    queryKey: [`item-sizes-${categoryName}`, { categoryName, subCategoryName }],
    queryFn: () =>
      fetchItemSizes({
        queryKey: [
          `item-sizes-${categoryName}`,
          { categoryName, subCategoryName },
        ],
      }),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!categoryName,
  });
};
